import { BadgeVariant } from '@aidkitorg/component-library/dist/types/src/Badge';
import { HideMessageReason } from './types';

export const SCALE_FACTOR = 1.25;

export const statusColors: Record<string, BadgeVariant> = {
  'delivered': 'success',
  'sent': 'info',
  'failed': 'error',
  'queued': 'neutral',
};

export const getStatusMap = (L: any): Record<string, string> => ({
  'delivered': L.applicant.comms.delivered,
  'sent': L.applicant.comms.sent,
  'failed': L.applicant.comms.failed,
  'queued': L.applicant.comms.queued,
});

export const getHideMessageReasonOptions = (L: any) => [
  { value: 'applicant_request' as HideMessageReason, label: L.applicant.comms.applicant_request },
  { value: 'sensitive_information' as HideMessageReason, label: L.applicant.comms.sensitive_information },
  { value: 'inappropriate_content' as HideMessageReason, label: L.applicant.comms.inappropriate_content },
];

// Avatar styling constants
export const AVATAR_COLORS = {
  system: 'bg-gray-300',
  inbound: 'bg-gray-300',
  outbound: 'bg-blue-600',
} as const;

// Transcript truncation
export const MAX_TRANSCRIPT_CHARS = 200;

// Audio metadata field names
export const AUDIO_FIELD_NAMES = ['RecordingUrl', 'MediaUrl0', 'recording_url'] as const;

// Contact type labels
export const CONTACT_LABELS = {
  PREVIOUS: 'previous_contact',
  CURRENT_EMAIL: 'current_email',
  CURRENT_PHONE: 'current_phone',
} as const;
